import { STORAGE_TOKEN_KEY } from '@/stores/mutation-type'
import { useLocalStorage } from '@vueuse/core'

const token = useLocalStorage(STORAGE_TOKEN_KEY, '')

function isLogin() {
  // 检查 token 和 userId 都存在
  const token = localStorage.getItem(STORAGE_TOKEN_KEY)
  const userId = localStorage.getItem('user_id')
  return !!(token && userId)
}

function getToken() {
  return token.value
}

function setToken(newToken: string) {
  token.value = newToken
}

function clearToken() {
  token.value = null
}

function getRefreshToken() {
  // 这里可以根据实际需求实现刷新token的逻辑
  return token.value
}

export { isLogin, getToken, setToken, clearToken, getRefreshToken }
